import React from "react";
import facebookIcon from "../assets/social-icon/facebook.svg";
import instagramIcon from "../assets/social-icon/ig.svg";
import linkedinIcon from "../assets/social-icon/linkedin.png";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-icons">
          <a
            href="https://www.instagram.com/starblackgioielli/?hl=it"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon-link"
          >
            <img src={instagramIcon} alt="Instagram" className="footer-icon" />
          </a>
          <a
            href="https://www.facebook.com/starblackgioielli"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon-link"
          >
            <img src={facebookIcon} alt="Facebook" className="footer-icon" />
          </a>
          <a
            href="https://www.linkedin.com/company/starblack-gioielli/?viewAsMember=true"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon-link"
          >
            <img src={linkedinIcon} alt="linkedin" className="footer-icon" />
          </a>
        </div>

        <div className="footer-text">
          <p className="footer-copyright">© 2026 Starblack Gioielli · Tutti i diritti riservati</p>
          {/* <p className="footer-credits">
            Sviluppato da{" "}
            <a
              href="https://saraferrantini-portfolio.web.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-credits-name"
            >
              Sara Ferrantini
            </a>
          </p> */}
        </div>

        <div className="scroll-to-top" onClick={scrollToTop}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12H8V20H16V12H20L12 4Z" fill="white" />
          </svg>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
